module.exports = __webpack_public_path__ + "img/img-143.7335c51d.png";